const checkSkillComplete = ({
  name,
  description,
  level,
  startedTrainingAge,
}) => {
  if (name && description && level && startedTrainingAge !== null) {
    return true;
  }

  return false;
};

export default checkSkillComplete;
